import { type ReactNode } from 'react';

type Tone = 'default' | 'primary' | 'success' | 'warning' | 'error';

// v3 badge — 토널 칩 (8px radius) + currentColor 도트 (색+텍스트 동시 전달, 색맹 안전)
const TONE_CLASS: Record<Tone, string> = {
  default: 'bg-surface-muted text-ink-muted',
  primary: 'bg-primary-soft text-primary-text',
  success: 'bg-success-soft text-success',
  warning: 'bg-warning-soft text-warning',
  error: 'bg-error-soft text-error',
};

export function Badge({ tone = 'default', children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-lg px-2.5 py-1 text-badge font-semibold ${TONE_CLASS[tone]}`}
    >
      <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-current" />
      {children}
    </span>
  );
}
